import 'css-chunksrc/client/common/layout/planzoneKnowledge/styles.scss';export default {
  "planzoneKnowledge": "_planzoneKnowledge_1niha_1",
  "icon": "_icon_1niha_8"
};